import React from 'react';

import { UnlockPersonalDataPopupProps } from './UnlockPersonalDataPopup.types';

import { Modal as CoreModal } from '@tangibleplay/core-ui';

const UnlockPersonalDataPopup = ({
  modalComponent: Modal = CoreModal,
  modalProps = {},
  titleSlot,
  formSlot,
  componentClassname = 'unlock-personal-data-popup',
  customClassnames = '',
  customStyle = '',
}: UnlockPersonalDataPopupProps) => {
  return (
    <Modal
      customClassnames={`${componentClassname} ${customClassnames}`}
      customStyle={`${customStyle}`}
      canOverlayClickCloseModal={false}
      hasButtonClose={false}
      {...modalProps}
    >
      {titleSlot && (
        <div className={`${componentClassname}__title-wrapper`}>
          {titleSlot}
        </div>
      )}
      {formSlot && (
        <div className={`${componentClassname}__form-wrapper`}>{formSlot}</div>
      )}
    </Modal>
  );
};
UnlockPersonalDataPopup.displayName = 'UnlockPersonalDataPopup';

export default UnlockPersonalDataPopup;
